import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import replacementService from "../services/replacements-service";
import DatePicker from "react-datepicker";
import { Multiselect } from "multiselect-react-dropdown";

const ReplacementsAndReturns = ({ history }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [tabIndex, setTabIndex] = useState(1);
    const [rxcode, setRxcode] = useState("");
    const [lookUpList, setLookUpList] = useState([]);
    const [facilityList, setFacilitiesList] = useState([]);
    const [facility, setFacility] = useState([]);
    const [endDate, setEndDate] = useState("");
    const [lookUp, setLookUp] = useState("");
    const multiselectRefFacility = useRef();


    async function handleReplacements() {
        try {
            setLoading(true);
            var params = {
                "rxf_number": rxcode
            }
            await replacementService.postReplacement(params);
            const { hide } = cogoToast.success("Replacement Successfully submitted",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setRxcode("");
            setLoading(false);

        } catch (e) {
            let errorMessage = e.msg ? e.msg.errorMessage : "Error while submitting  details. Please try after sometime.";
            const { hide } = cogoToast.error(errorMessage,
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
    }
    async function handleReRuns() {
        if (endDate?.length === 0 || facility?.length === 0 || lookUp.length === 0) {
            setError(true);
            return;
        } else {
            setError(false);
        }
        try {
            setLoading(true);
            var params = {
                "fil_date": endDate,
                "fac_id": facility[0].id,
                "lookup_id": lookUp
            }
            await replacementService.postReRuns(params);
            setEndDate("");
            setFacility([]);
            setLookUp("");
            multiselectRefFacility.current.resetSelectedValues();
            const { hide } = cogoToast.success("Re-Run Successfully submitted",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        } catch (e) {
            let errorMessage = e.msg ? e.msg.errorMessage : "Error while submitting  details. Please try after sometime.";
            const { hide } = cogoToast.error(errorMessage,
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
    }
    async function getDefaults() {
        try {
            setLoading(true);
            let resp = await replacementService.getDefaults();
            setFacilitiesList(resp?.facilities);
            setLookUpList(resp?.lookups);
            setLoading(false);
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error while getting  details. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
    }

    useEffect(() => {
        getDefaults();
    }, []);
    return (
        <>
            <CipHeader />
            <div
                className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000} //3 secs
                />
            </div>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md p-4">
                <ul
                    className={` p-2  mb-0 flex pt-3  `}
                    role="tablist"
                >  <li className="mr-2  text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 1 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(1);
                            }}
                            data-toggle="tab"
                            role="tablist"
                        >
                            REPLACEMENTS
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 2 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(2);
                            }}
                            data-toggle="tab"
                            href="#link2"
                            role="tablist"
                        >
                            RE-RUNS
                        </a>
                    </li>

                </ul>
                {tabIndex === 1 && <div>
                    <div className="w-full text-darkclr font-semibold leading-10  py-8  text-center	">
                        <span className="text-xl">
                            REPLACEMENTS
                        </span>
                    </div>
                    <ul className="text-left">
                        <li className=" text-xs pr-3 leading-6 text-menu_txt w-full mb-6 ">
                            <div className="flex w-full justify-center">

                                <div className="w-1/3">
                                    <input
                                        type="number"
                                        name="rxCode"
                                        id="rxCode"
                                        value={rxcode}
                                        autoFocus={true}
                                        placeholder="Scan RX Number"
                                        onChange={(e) => setRxcode(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleReplacements();
                                            }
                                        }}
                                        className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
                                    />
                                </div>
                            </div>
                        </li>
                        <li className=" text-xs pr-3 leading-6 text-menu_txt  center mb-3 pl-2 flex justify-center">
                            <button
                                className={
                                    rxcode?.length === 0
                                        ? "opacity-50 cursor-not-allowed px-3 py-2  text-rounded font-medium h-10 text-white  bg-header_bg my-3 mr-4 focus:outline-none text-sm"
                                        : "rounded font-medium h-10  px-3 py-2 text-white bg-header_bg my-3 focus:outline-none text-sm"
                                }
                                aria-label="Submit"
                                onClick={() => handleReplacements()}
                            >
                                SUBMIT
                            </button>
                        </li>
                    </ul>
                </div>
                }
                {tabIndex === 2 && <div>
                    <div className="w-full text-darkclr font-semibold leading-10  py-8  text-center	">
                        <span className="text-xl">
                            RE-RUNS
                        </span>
                    </div>
                    <ul className="text-left px-36">
                        <li className=" text-xs pr-3 leading-6 text-menu_txt w-full mb-6 ">
                            <label className="text-labelclr font-semibold text-sm tracking-wider">
                                Facility
                            </label>
                            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                            {facilityList ? (
                                <Multiselect
                                    name="faciltyList"
                                    displayValue="dname"
                                    selectedValues={facility}
                                    options={facilityList}
                                    ref={multiselectRefFacility}
                                    avoidHighlightFirstOption={true}
                                    selectionLimit={1}
                                    hidePlaceholder={true}
                                    caseSensitiveSearch={false}
                                    onSelect={(selectedList, selectedItem) => {
                                        setFacility([selectedItem]);
                                    }}
                                    onRemove={() => {
                                        setFacility([]);
                                    }}
                                />
                            ) : (
                                ""
                            )}
                            {error && facility?.length === 0 && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                    You must select facility
                                </p>
                            )}
                        </li>
                        <li className=" text-xs pr-3 leading-6 text-menu_txt w-full mb-6 ">
                            <label className="text-labelclr font-semibold text-sm tracking-wider">
                                Date
                            </label>
                            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                            <div className="reruns-date-picker">
                                <DatePicker
                                    placeholderText="MM/DD/YYYY"
                                    selected={endDate}
                                    onChange={(dob) => {
                                        setEndDate(dob);
                                    }}
                                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full  text-fogotpwsd_login text-sm"
                                />
                            </div>
                            {error && endDate?.length === 0 && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                    You must select date
                                </p>
                            )}
                        </li>
                        <li className=" text-xs pr-3 leading-6 text-menu_txt w-full mb-6 ">
                            <label className="text-labelclr font-semibold text-sm tracking-wider">
                                Type
                            </label>
                            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                            <div>
                                <select
                                    name="lookUp"
                                    aria-label="Select"
                                    onChange={(e) => setLookUp(e.target.value)}
                                    value={lookUp}
                                    className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                                >
                                    <option value="">Select</option>
                                    {lookUpList
                                        ? lookUpList.map((item, i) => {
                                            return (
                                                <option key={i} value={item.id}>
                                                    {item.value}
                                                </option>
                                            );
                                        })
                                        : null}

                                </select>
                            </div>
                            {error && lookUp?.length === 0 && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                    You must select a value
                                </p>
                            )}
                        </li>
                        <li className=" text-xs pr-3 leading-6 text-menu_txt  center mb-3 pl-2 flex justify-center">
                            <button
                                className={
                                    "rounded font-medium h-10  px-3 py-2 text-white bg-header_bg my-3 focus:outline-none text-sm"
                                }
                                aria-label="Submit"
                                onClick={() => handleReRuns()}
                            >
                                SUBMIT
                            </button>
                        </li>
                    </ul>
                </div>
                }

            </div>
        </>
    );
};

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(ReplacementsAndReturns)
);